import { useState } from "react";
import { handleVideoDragEnd } from "src/libs/drag-drop-lib";
import { useVideoDragDropSensors } from "src/hooks/useVideoDragDropSensors";

type UseDragAndDropProps<Item> = {
  moveItem: (args: {
    /** The original position of the item */
    oldIndex: number;
    /** The new position of the item */
    newIndex: number;
  }) => Promise<void>;
  getItemFromId: (itemId: string) => Item | undefined;
};

export const useDragAndDrop = <Item>({
  moveItem,
  getItemFromId,
}: UseDragAndDropProps<Item>) => {
  const sensors = useVideoDragDropSensors();
  const [draggingItem, setDraggingItem] = useState<Item | null>(null);

  function handleDragStart(e: any) {
    const item = getItemFromId(e?.active?.id);

    if (item) {
      setDraggingItem(item);
    }
  }

  const handleDragEnd = handleVideoDragEnd(
    ({ oldIndex, newIndex }) => {
      moveItem({ oldIndex, newIndex });

      setDraggingItem(null);
    },
    () => {
      setDraggingItem(null);
    }
  );

  const handleDragCancel = () => {
    setDraggingItem(null);
  };

  return {
    sensors,
    draggingItem,
    handleDragStart,
    handleDragEnd,
    handleDragCancel,
  };
};

export type UseDragAndDropResult<Item> = ReturnType<
  typeof useDragAndDrop<Item>
>;
